export default "__VITE_ASSET__DOvmir8C__"